export default __webpack_public_path__ + "static/media/clip-disabled.716a7bc9.svg";